import React from 'react';
import {Header, Breadcrumb, Container,Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio} from 'semantic-ui-react';
import { Link } from "react-router-dom";


const ReferenciaBancariaForm=({ id, color, form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos, tipoPagoCombo})=>{



	return (
        <Container>
          <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big' inline content={strings?strings["Procesando"]:""}/>
          </Dimmer>

				<Header     dividing>             
					<Header.Content>{strings?strings["ReferenciaBancaria"]:""}</Header.Content>
				</Header>
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >       
        
            
                            <Form.Field  required  error={errors.nombreBanco}>            
                              <label  >{strings?strings["nombreBanco"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["nombreBanco"]:""} 
                                    name="nombreBanco"
                                    onChange={onChange}
                                    value={datos.nombreBanco}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.convenio}>            
                              <label  >{strings?strings["convenio"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["convenio"]:""} 
                                    name="convenio"
                                    onChange={onChange}
                                    value={datos.convenio}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.beneficiario}>            
                              <label  >{strings?strings["beneficiario"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["beneficiario"]:""} 
                                    name="beneficiario"
                                    onChange={onChange}
                                    value={datos.beneficiario}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.noCuenta}>            
                              <label  >{strings?strings["noCuenta"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["noCuenta"]:""} 
                                    name="noCuenta"
                                    onChange={onChange}
                                    value={datos.noCuenta}
                                    icon='edit'/>
                            </Form.Field>

                                            
                            <Form.Field  required  error={errors.tipoPagoId}>
                                      <label  >{strings?strings["tipoPagoId"]:""}</label>
                                      <Dropdown 
                                            placeholder={strings?strings["tipoPagoId"]:""} 
                                            name="tipoPagoId"
                                             fluid 
                                            search 
                                            selection
                                            onChange={onChange}
                                            value={datos.tipoPagoId}
                                            options={tipoPagoCombo}/>
                                    </Form.Field>
               
                                                                        
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                <Link to="/referenciabancarias">
                                    <Button  
										>{strings?strings["regresar"]:""}</Button>
                                </Link>
                                <Button.Or text=" "></Button.Or>
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        </Container>
	);
};



export default ReferenciaBancariaForm;